import open from "webmodals/open";
import controller from "emun.cart/cart-item-ship-date.controller";
import templateUrl from "emun.cart/cart-item-ship-date.htm";

export default ({
  size = "md",
  backdrop = "static",
  placement = "center",
  preventAutoHeight = true,
  cartItem = {},
  product = cartItem.product,
  title = product ? `Select Ship Date for ${product.id}` : 'Select Ship Date'
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    placement,
    controller,
    resolve: {
      preventAutoHeight: () => preventAutoHeight,
      title: () => title,
      cartItem: () => cartItem,
      product: () => product
    },
    bindToController: true,
    controllerAs: "$ctrl"
  }).result;
